import valueType from 'src/helpers/valueType';

interface ObjInterface {
  [key: string]: unknown;
}

export function updateDynamicObject(data: any, path: string[], updateValue: unknown): any {
  const dataType = valueType(data);
  const pathValue: string | undefined = path.shift();

  if (pathValue === undefined) {
    return data;
  }

  if (path.length === 0) {
    if (dataType === 'array') {
      const duplicateArray = data.slice();
      duplicateArray[pathValue] = updateValue;
      return duplicateArray;
    }
    if (dataType === 'object') {
      return {
        ...data,
        [pathValue]: updateValue
      };
    }
  }

  if (dataType === 'array') {
    const duplicateArray = data.slice();
    duplicateArray[pathValue] = updateDynamicObject(data[pathValue], path, updateValue);
    return duplicateArray;
  }

  return {
    ...data,
    [pathValue]: updateDynamicObject(data[pathValue], path, updateValue)
  };
}

export function getAvailableKeys(obj: ObjInterface, restrictedData: string[] = []): string[] {
  const objectKeys: string[] = Object.keys(obj);
  let accessibleKeys: string[] = [...objectKeys];

  if (restrictedData.length !== 0) {
    accessibleKeys = objectKeys.filter((key: string) => {
      const isDataRestricted: boolean = restrictedData.includes(key);
      if (isDataRestricted) {
        return false;
      }
      return true;
    });
  }

  return accessibleKeys;
}
